import httpClient from '@/shared/http-payment-client';

const getOrderById = (orderId) => httpClient.get(`/orders/${orderId}?$expand=billingCustomer`);
const getOrders = () => httpClient.get('/orders/');
export {
  getOrderById,
  getOrders,
};
